import React from 'react';
import { Modal, Form, Table, Button, InputGroup } from 'react-bootstrap';
import { FaTrash, FaPlus, FaListAlt } from 'react-icons/fa';

export const ModItemsModal = ({
  show,
  onHide,
  currentModGroup,
  modItems,
  handleAddChoiceRow,
  handleModItemChange,
  handleAutoSaveChoice,
  handleShowModBom,
  confirmDelete
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title style={{ color: "#1e3c72", fontWeight: 700 }}>
          Choices for: {currentModGroup?.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <p className="text-muted m-0">Changes are saved automatically when you edit a field.</p>
          <Button variant="outline-primary" size="sm" onClick={handleAddChoiceRow}>
            <FaPlus className="me-2" /> Add Choice
          </Button>
        </div>
        
        <Table bordered hover className="align-middle bg-white shadow-sm">
          <thead className="bg-light">
            <tr>
              <th style={{ width: "40%" }}>Choice Name</th>
              <th style={{ width: "20%" }}>Price Adjust (+THB)</th>
              <th className="text-center" style={{ width: "10%" }}>Is Default?</th>
              <th className="text-center" style={{ width: "10%" }}>Active?</th>
              {currentModGroup?.id && <th className="text-center" style={{ width: "10%" }}>Recipe</th>}
              <th className="text-center" style={{ width: "10%" }}>Remove</th>
            </tr>
          </thead>
          <tbody>
            {modItems.length === 0 ? (
              <tr><td colSpan={5} className="text-center py-4 text-muted">No choices added yet. Click "Add Choice" to begin.</td></tr>
            ) : modItems.map((item, index) => (
              <tr key={item.id || index}>
                <td>
                  <Form.Control type="text" value={item.name} 
                    onChange={(e) => handleModItemChange(index, 'name', e.target.value)}
                    onBlur={() => handleAutoSaveChoice(item)}
                  />
                </td>
                <td>
                  <InputGroup>
                    <InputGroup.Text>฿</InputGroup.Text>
                    <Form.Control type="number" step="0.01" value={item.price_adjust} 
                      onChange={(e) => handleModItemChange(index, 'price_adjust', e.target.value)}
                      onBlur={() => handleAutoSaveChoice(item)}
                    />
                  </InputGroup>
                </td>
                <td className="text-center">
                  <Form.Check type="checkbox" checked={item.is_default} 
                    onChange={(e) => {
                      handleModItemChange(index, 'is_default', e.target.checked);
                      handleAutoSaveChoice({ ...item, is_default: e.target.checked });
                    }}
                  />
                </td>
                <td className="text-center">
                  <Form.Check type="switch" checked={item.is_active} 
                    onChange={(e) => {
                      handleModItemChange(index, 'is_active', e.target.checked);
                      handleAutoSaveChoice({ ...item, is_active: e.target.checked });
                    }}
                  />
                </td>
                {currentModGroup?.id && (
                  <td className="text-center">
                    <Button variant="outline-secondary" size="sm" onClick={() => handleShowModBom(item)} disabled={!item.id} title={!item.id ? "Save choice first" : "Edit Recipe"}><FaListAlt /></Button>
                  </td>
                )}
                <td className="text-center">
                  <Button variant="outline-danger" size="sm" onClick={() => confirmDelete('mod_item', item.id, item.name, currentModGroup?.id, index)}><FaTrash /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="primary" onClick={onHide} style={{ background: "#1e3c72" }}>Done</Button>
      </Modal.Footer>
    </Modal>
  );
};
